import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import PodcastCard from '../../components/PodcastCard/PodcastCard';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import './Podcast.css';

function Podcast() {
    const [podcasts, setPodcasts] = useState([]);
    const [filteredPodcasts, setFilteredPodcasts] = useState([]);
    const [visiblePodcasts, setVisiblePodcasts] = useState(10);
    const [user, setUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);

    const getPodcasts = async () => {
        try {
            setLoading(true);
            toast.loading("در حال بارگذاری پادکست‌ها...");
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/podcasts`);
            toast.dismiss();
            toast.success("پادکست‌ها با موفقیت بارگذاری شدند!");
            const podcastsData = response.data || [];
            setPodcasts(podcastsData);
            setFilteredPodcasts(podcastsData);
        } catch (err) {
            console.error(err);
            toast.error("خطا در بارگذاری پادکست‌ها");
            setPodcasts([]);
            setFilteredPodcasts([]);
        } finally {
            setLoading(false);
        }
    };

    // اعمال فیلتر جستجو
    const applyFilters = () => {
        let filtered = [...podcasts];
        
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(podcast =>
                (podcast.title && podcast.title.toLowerCase().includes(term)) ||
                (podcast.description && podcast.description.toLowerCase().includes(term))
            );
        }
        
        setFilteredPodcasts(filtered);
        setVisiblePodcasts(10);
    };

    useEffect(() => {
        applyFilters();
    }, [searchTerm, podcasts]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const resetFilters = () => {
        setSearchTerm('');
    };

    const loadMore = () => {
        setVisiblePodcasts(visiblePodcasts + 10);
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('currentUser');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        getPodcasts();
    }, []);

    const displayPodcasts = filteredPodcasts || [];
    const hasMore = visiblePodcasts < displayPodcasts.length;

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="podcast-container">
                    <div className="container mt-4">
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">در حال بارگذاری پادکست‌ها...</p>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="podcast-container">
                <div className="container mt-4">
                    <div className="search-field mt-5 pt-2">
                        <h3 className="text-center mb-3">🎙️ Podcasts</h3>
                        
                        {/* جستجو */}
                        <div className="filters-container">
                            <div className="filter-group">
                                <input
                                    type="text"
                                    className="form-control search-input"
                                    onChange={handleSearch}
                                    placeholder="Search by title or description..."
                                    value={searchTerm}
                                />
                            </div>
                            <button className="btn-reset-filters" onClick={resetFilters}>
                                Reset search
                            </button>
                        </div>
                        
                        {/* دکمه Add New Podcast برای ادمین */}
                        {user && user.role === 'admin' && (
                            <div className="add-book-btn-container">
                                <Link to="/add-podcast" className="btn btn-danger">➕ افزودن پادکست جدید</Link>
                            </div>
                        )}
                    </div>

                    {/* تعداد نتایج */}
                    <div className="results-count">
                        {displayPodcasts.length} Podcasts found
                    </div>

                    {/* لیست پادکست‌ها */}
                    <div className="podcasts-list">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                            {displayPodcasts.slice(0, visiblePodcasts).map((podcast) => (
                                <PodcastCard key={podcast._id} {...podcast} />
                            ))}
                            {displayPodcasts.length === 0 && (
                                <div className="text-center w-100 py-5">
                                    <h5>هیچ پادکستی پیدا نشد</h5>
                                    <button className="btn btn-link" onClick={resetFilters}>پاک کردن فیلترها</button>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {hasMore && (
                        <div className="d-flex mt-4 justify-content-center">
                            <button className="btn-load-more" onClick={loadMore}>
                                بارگذاری بیشتر
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Podcast;